import moment from "moment";
import { isAllowedRiderCode, showCoverageAmountForBenefit } from "js/utilities";

export const filterAndFormatRiderPolicies = (riders) => {
  // console.log(riders);
  return (
    riders
      // remove expired
      .filter(
        (benefit) =>
          (benefit?.isRider || isAllowedRiderCode(benefit.type)) &&
          moment(benefit.expiryDate).isAfter(moment())
      )
      .sort((a, b) =>
        // first to expire shows first
        moment(a.expiryDate, "DD-MM-YYYY").isBefore(
          moment(b.expiryDate, "DD-MM-YYYY")
        )
          ? -1
          : 1
      )
      .sort((a, b) => (!showCoverageAmountForBenefit(a.type) ? -1 : 1))
  );
};
